const urls = {
    auth: {
        sendOtp: '/auth/send-code',
        verifyOtp: '/auth/verify-code',
        firebaseSignIn: '/auth/firebase/sign-in',
        getMe: '/auth/me',
        logout: '/auth/logout',
        devices: '/auth/devices',
        logoutDevice: '/auth/logout-device'
    },
    admin: {
        users: '/admin/users'
    },
    dishes: {
        dishesD: '/dishes'
    },
    menu: {
        availableDishes: '/available-dishes',
        sampleMenu: '/packs',
        sampleMenuDishes: '/sample-menu-dishes',
        menuDishes: '/packs/date',
        menuDishCreate: '/menu-dishes'
    },
    orders: {
        menuDishesDate: '/packs/dates',
        ordersR: '/orders'
    },
    semiFinished: {
        semiFinishedR: '/semi-finished',
    },
    clients: {
        clientsR: '/users'
    },
    settings: {
        category: '/categories',
        meals: '/meals',
        packs: '/packs',
        periods: '/periods',
        price: '/prices',
        promoCodes: '/promo-codes',
        products: '/products',
        productGroups: '/product-groups',
        productBrands: '/product-brands',
        dietType: '/diet-type',
        dietMode: '/diet-mode',
        packCategories: '/pack-categories',
        settingsR: '/',
        appSettings: '/settings',
    },
    cycleMenu: {
        cycleDishesR: '/cycle-menu-dishes',
    },
    cycleAvailableDishes: {
        cycleAvailableDishesR: '/cycle-available-dishes',
    },
    promoCodes: {
        promoCodesR: '/promo-codes'
    },
    statistics: {
        promoCodeUsage: '/statistics/promo-code-usage',
        clientRegistrations: '/statistics/client-registrations',
        dishesCountChart: '/statistics/dishes-count-chart'
    },
    messages: {
        quizResponse: '/wellness-quiz',
        changelog: '/orders/changelog',
    },
    siteConfig: {
        adminConfig: '/site-config/admin-config',
        sections: '/site-config',
        history: '/site-config/history',
        undo: '/site-config/undo',
        reset: '/site-config/reset',
        public: '/site-config/public',
        uploadImage: '/site-config/upload-image',
    },
}

export {
    urls
}